import { render, staticRenderFns } from "./festivalVideo.vue?vue&type=template&id=1d7a11cb&scoped=true&"
import script from "./festivalVideo.vue?vue&type=script&lang=js&"
export * from "./festivalVideo.vue?vue&type=script&lang=js&"
import style0 from "./festivalVideo.vue?vue&type=style&index=0&id=1d7a11cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7a11cb",
  null
  
)

export default component.exports